import { IRootState } from '../../../../store'
import { ICardiacArrestState } from '../store/cardiacArrest.types'

export const getCardiacArrestSelector = (state: IRootState): ICardiacArrestState => state.cardiacArrest
